export const formatCatalogPrice = (price, locale = 'en-IN') => {
  if (!price) return null;
  return new Intl.NumberFormat(locale, { style: 'currency', currency: price.currency, maximumFractionDigits: 2 }).format(price.amountMinor / 100);
};
